import styled from "styled-components";
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  outline: none;
  
  .active {
    border: 1px solid ${colors.brightBlue};
  }
  
  .inactive {
    border: 1px dashed ${colors.silver};
  }
`;

export const FileInputWrapper = styled.div`
  padding: 32px;
  cursor: pointer;
  border-radius: 4px;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  
  * {
    margin: 4px;
  }

  label {
    margin: 0;
    cursor: pointer;
  }
  
  svg {
    fill: ${colors.slateGrey};
    height: 18px;
    width: auto;
  }
`;

export const Placeholder = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};
 
  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;
